import UserOrder from './UserOrder'
import PopServer from './PopServer'
import PrivateLine from './PrivateLine'
import NetworkTopology from './NetworkTopology'
import SaaSAcceleration from './SaaSAcceleration'
import FlowLog from './FlowLog'
import CrossBorder from './CrossBorder'
import DialTest from './DialTest'

export default {
  PleaseSelectUser: 'Please select a customer',

  UserOrder,
  PopServer,
  PrivateLine,
  NetworkTopology,
  SaaSAcceleration,
  FlowLog,
  CrossBorder,
  DialTest
}